import React, { useEffect, useState } from "react";
import api from "../../services/api";
import Statistics from "./Statistics";
import Preferences from "./Preferences";
import UserData from "./UserData";

const UserProfile = () => {
    const [userProfile, setUserProfile] = useState({});
    const [loading, setLoading] = useState(true);

    const handleUserIndexPreference = (userPreference) => {
        if (userProfile.userPreferences?.index_preference_id !== userPreference) {
            setUserProfile(prev => ({
                ...prev,
                userPreferences: { ...prev.userPreferences, index_preference_id: userPreference },
            }));
        }
    };

    const handleUserLanguage = (userLanguage) => {
        if (userProfile.userPreferences?.default_language_id !== userLanguage) {
            setUserProfile(prev => ({
                ...prev,
                userPreferences: { ...prev.userPreferences, default_language_id: userLanguage },
            }));
        }
    };

    const handleUserData = (userData) => {
        setUserProfile(prev => ({
            ...prev,
            user: { ...prev.user, name: userData.name, email: userData.email },
        }));
    };

    useEffect(() => {
        api.get('/userProfile')
            .then(response => setUserProfile(response.data))
            .catch(error => console.error('Error fetching profile:', error))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center py-24">
                <div className="text-center">
                    <span className="text-4xl animate-pulse">📚</span>
                    <p className="mt-4 text-warm-400 font-medium">Loading your profile…</p>
                </div>
            </div>
        );
    }

    if (!userProfile.user) {
        return <p className="text-center text-warm-400 py-24">No profile data available.</p>;
    }

    const initials = userProfile.user.name?.slice(0, 2).toUpperCase() ?? '?';

    return (
        <div>
            {/* Header */}
            <div className="bg-white rounded-2xl border border-warm-200 shadow-sm p-8 mb-6 flex items-center gap-6">
                <div className="w-16 h-16 rounded-full bg-warm-200 flex items-center justify-center flex-shrink-0">
                    <span className="font-serif text-2xl font-bold text-warm-700">{initials}</span>
                </div>
                <div>
                    <h1 className="font-serif text-3xl font-bold text-warm-800">{userProfile.user.name}</h1>
                    <p className="text-warm-400 mt-0.5 text-sm">{userProfile.user.email}</p>
                </div>
            </div>

            {/* Stats row */}
            <Statistics
                averageRanking={userProfile.averageRanking}
                bookNotStarted={userProfile.bookNotStarted}
                bookFinished={userProfile.booksFinished}
                bookStarted={userProfile.bookStarted}
                totalBooks={userProfile.user.books.length}
            />

            {/* Preferences + Personal info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Preferences
                    userPreferences={userProfile.userPreferences}
                    indexPreferences={userProfile.indexPreferences}
                    defaultLanguages={userProfile.defaultLanguages}
                    handleUserIndexPreference={handleUserIndexPreference}
                    handleUserLanguage={handleUserLanguage}
                />
                <UserData
                    userEmail={userProfile.user.email}
                    userName={userProfile.user.name}
                    handleUserData={handleUserData}
                />
            </div>
        </div>
    );
};

export default UserProfile;
